import { fork, put } from 'redux-saga/effects';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import Responsibility from '../../../Feature/Responsibility';
import { whenResponsible } from '../../../Feature/responsible';
import { whenCapable } from '../../../Feature/capable';
import { withDependencies } from '../../../DI/dependencyInjection';
import { createSystemLogAction } from '../../../SystemLogs/systemLogActionFactory';
import { DisplayConnectedOverSerial } from '@signageos/common-types/dist/Device/SystemLogs/systemLogs';
import Debug from 'debug';

const debug = Debug('@signageos/front-display:Management:Device:DisplayManagerSaga');

export const displayManagerSaga = whenResponsible(
	Responsibility.DISPLAY_MANAGER,
	whenCapable(ManagementCapability.DISPLAY_MANAGER, displayManagerSagaDefault),
);

function* displayManagerSagaDefault() {
	yield fork(
		whenCapable(
			ManagementCapability.DISPLAY_MANAGER,
			withDependencies(['managementDriver', 'featureFlags'], function* ({ managementDriver, featureFlags }) {
				if (featureFlags?.systemLogs ?? true) {
					try {
						const connectedDisplay: string | undefined = yield managementDriver.displayManager.getConnectedDisplay();
						if (typeof connectedDisplay !== 'undefined') {
							debug(`Connected display: ${connectedDisplay}`);
							yield put(
								createSystemLogAction({
									type: DisplayConnectedOverSerial,
									display: connectedDisplay,
								}),
							);
						}
					} catch (error) {
						console.warn(
							`Failed to connect to display over serial. Reconnect the display and restart application.\nError: ${(error as Error).message}`,
						);
					}
				}
			}),
		),
	);
}
